const initialState: Array<object> = [];

/**
 * partListReducer: Reducer to handle actions related to the part list data.
 *
 * @param {any} state - The current state of the part list data.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {any} The new state after applying the action.
 */
const partListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_PART_LIST_DATA":
      return action?.payload;
      break;
    default:
      return state;
  }
};

export default partListReducer;
